// Maps accounts.models.Role (backend) to this app's three portals, and
// formats the /auth/me user for display in each portal's topbar. Role
// values and their human labels come straight from the backend's
// `Role.choices` (BACKEND_API_FLOW.md §2): icib_admin/"ICIB Admin",
// employer_admin/"Employer Admin", employee/"Employee".
const ROLE_HOME = {
  icib_admin: '/dashboard',
  employer_admin: '/employer',
  employee: '/employee',
};

export function roleHome(role) {
  return ROLE_HOME[role] || '/';
}

export function userLabel(user, roleTitle) {
  if (!user) return '';
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ');
  return `${name || user.email} · ${roleTitle}`;
}

export function userInitials(user) {
  if (!user) return '';
  const { first_name, last_name, email } = user;
  const initials = `${(first_name || '')[0] || ''}${(last_name || '')[0] || ''}`.toUpperCase();
  return initials || (email ? email[0].toUpperCase() : '?');
}
